import { render, staticRenderFns } from "./GridInventoryReport.vue?vue&type=template&id=2345f772&"
import script from "./GridInventoryReport.vue?vue&type=script&lang=ts&"
export * from "./GridInventoryReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports